import { useMemo } from "react";
import { useSelector } from "react-redux";
import { buildAPIQueryParams } from "helpers/utility/queryUtils";
import useAllQueryParamsFilters from "hooks/useAllQueryParamsFilters";
import { type GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQueryParams } from "vl-api/vlComponents";

export const useGetExplorationQueryParams = () => {
  const singleDataset = useSelector((state: any) => state.singleDataset);
  const queryParamsFilters = useAllQueryParamsFilters();

  const explorationQueryParams = useMemo(() => {
    const params = {
      ...buildAPIQueryParams(singleDataset, queryParamsFilters),
      page_number: undefined,
    };
    return params as GetDatasetLabelNamesApiV1ExploreDatasetIdLabelsGetQueryParams;
  }, [singleDataset, queryParamsFilters]);

  return explorationQueryParams;
};
